import React from 'react';
import { Spin as AntSpin } from 'antd';
import type { SpinProps as AntSpinProps } from 'antd/lib';
import { useTranslation } from 'react-i18next';
import UiKit from '../index';
import styled from 'styled-components';

interface SpinProps extends AntSpinProps {}

function Spin({ ...rest }: SpinProps) {
  return <AntSpin {...rest} />;
}

export { Spin };
